import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import Footer from '../../components/Layout/Footer';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/page-header-bg.jpg';
import CtaSection from '../../components/Common/CtaSection';
import shapeImageUrl from '../../assets/images/shapes/cta-one-shape-1.png';
import ProjectMain from './ProjectMain';

const Project = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <React.Fragment>
            <Header
                navImg={navImg1}
                parentMenu='infrastructure'
                activeMenu="/infrastructure"
            />
            
            <SiteBreadcrumb
                pageTitle="Our Infrastructure"
                pageName="Our Infrastructure"
                breadcrumbsImg={bannerbg}
            />

            {/* Infrastructure Slider Section */}
            <section className="infrastructure-section" style={{ padding: "80px 0", backgroundColor: "#f7f7f7" }}>
                <div className="container">
                    {/* Section Title Design */}
                    <div className="section-title text-center" style={{ marginBottom: "50px" }}>
                        <span style={{ 
                            color: "#ff5e14", 
                            textTransform: "uppercase", 
                            fontWeight: "bold", 
                            letterSpacing: "1px" 
                        }}>
                            Modern Facilities
                        </span>
                        <h2 style={{ 
                            fontSize: "36px", 
                            fontWeight: "800", 
                            marginTop: "10px",
                            color: "#1c1c1c"
                        }}>
                            Infrastructure That Inspires <br /> Confidence
                        </h2>
                        <div style={{ 
                            width: "70px", 
                            height: "3px", 
                            backgroundColor: "#ff5e14", 
                            margin: "20px auto" 
                        }}></div>
                    </div>

                    {/* Slider Component */}
                    <ProjectMain />
                </div>
            </section>

            <CtaSection
                className="cta-one cta-two"
                breadcrumbsImg={bannerbg}
                shapeImageUrl={shapeImageUrl}
                title="Need any help? contact us!"
                text="Need help?"
                phoneNumber=" 9983333188"
            />

            <BackToTop scroll={isVisible} />
            <Footer />
        </React.Fragment>
    );
}

export default Project;